/**
 * @generated SignedSource<<8c6129c7b2c512389d8c54d112edda98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilterTaxonomySelector_mapTaxonomy"
    }
  ],
  "type": "MapTaxonomy",
  "abstractKey": null
};

node.hash = "6d825e75d5bd48b859395cbb718e6ec2";

module.exports = node;
